var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"op-68",attrs:{"loading":_vm.loading,"text":"","icon":""},on:{"click":_vm.refresh}},[_c('v-icon',[_vm._v("sync")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }